import { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import { ProductCarouselNew } from '@features/products-carousel'

export default function NewProductsBlock (_props: BlockProps) {
  return <ProductCarouselNew />
}